"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedMoseyLayout = exports.MoseyLayout = exports.THROTTLE_DELAY = void 0;
const react_1 = __importStar(require("react"));
const Header_1 = __importDefault(require("../Partials/Header/Header"));
const Footer_1 = __importDefault(require("../../Components/UI/Footer"));
const AppProvider_1 = __importDefault(require("./AppProvider"));
const react_redux_1 = require("react-redux");
const LoginModalWrapper_1 = __importDefault(require("../LoginModalWrapper/LoginModalWrapper"));
const ErrorPage_1 = __importDefault(require("../Page/ErrorPage/ErrorPage"));
const TopPageLink_1 = __importDefault(require("../../Components/UI/TopPageLink"));
const createThrottle_1 = __importDefault(require("../../Hooks/createThrottle"));
const Utils_1 = require("@/Utils");
const FavoriteShiptosModalWrapper_1 = __importDefault(require("../FavoriteShiptosModalWrapper/FavoriteShiptosModalWrapper"));
const LogoutModalWrapper_1 = __importDefault(require("../LogoutModalWrapper"));
exports.THROTTLE_DELAY = 200;
const SCROLL_DURATION = 150;
const MoseyLayout = props => {
    var _a, _b;
    const content = (_a = props.initialState) === null || _a === void 0 ? void 0 : _a.IContent;
    const errorPages = (0, Utils_1.objectToCamelCase)((_b = props.initialState) === null || _b === void 0 ? void 0 : _b.ErrorPages);
    const isContentPage = content || process.env.NODE_ENV === 'development';
    const [showTopPageLink, setShowTopPageLink] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handleScroll = () => {
            setShowTopPageLink(window.scrollY >= 300);
        };
        const throttledFunc = (0, createThrottle_1.default)(() => handleScroll(), exports.THROTTLE_DELAY);
        window.addEventListener('scroll', throttledFunc);
        return () => {
            window.removeEventListener('scroll', throttledFunc);
        };
    }, []);
    const notFoundPage = errorPages === null || errorPages === void 0 ? void 0 : errorPages.notFoundPage;
    return (react_1.default.createElement(AppProvider_1.default, null,
        react_1.default.createElement("div", { className: "mosey-layout" },
            react_1.default.createElement(Header_1.default, null),
            isContentPage ? (react_1.default.createElement("div", { className: "content" }, props.children)) : (react_1.default.createElement(ErrorPage_1.default, { pageData: notFoundPage, title: notFoundPage === null || notFoundPage === void 0 ? void 0 : notFoundPage.title, body: notFoundPage === null || notFoundPage === void 0 ? void 0 : notFoundPage.body, links: notFoundPage === null || notFoundPage === void 0 ? void 0 : notFoundPage.links, isNotFoundPage: true })),
            react_1.default.createElement(Footer_1.default, { copyrightInsideContainer: false })),
        react_1.default.createElement(LoginModalWrapper_1.default, null),
        react_1.default.createElement(FavoriteShiptosModalWrapper_1.default, null),
        react_1.default.createElement(LogoutModalWrapper_1.default, null),
        react_1.default.createElement(TopPageLink_1.default, { isOnScreen: showTopPageLink, onClick: () => (0, Utils_1.scrollToTop)(SCROLL_DURATION) })));
};
exports.MoseyLayout = MoseyLayout;
exports.ConnectedMoseyLayout = (0, react_redux_1.connect)((state, ownProps) => {
    const propsFromState = state.OptiContentCloud || {};
    return Object.assign(Object.assign({}, ownProps), propsFromState);
})(exports.MoseyLayout);
exports.default = exports.ConnectedMoseyLayout;
